class preventSubmit {
  constructor() {
    this.form = document.querySelector('.js-prevent-submit');
    if (!this.form) return;
    this.requiredInput = this.form.querySelector('.js-required-input');
    this.requiredMessage = this.form.querySelector('.js-required-message');
    this.requiredRecaptchaMessage = this.form.querySelector('.js-required-recaptcha-message');
    this.submit = this.form.querySelector('.js-submit');
    this.init();
  }

  init() {
    // Prevent native browser error messages
    this.requiredInput.addEventListener('invalid', event => {
      event.preventDefault();
    });

    // Prevent form submission
    this.form.addEventListener('submit', event => {
      event.preventDefault();
    });

    // Submit only on button press. Because IE9.
    this.submit.addEventListener('click', () => {
      if (grecaptcha && !grecaptcha.getResponse() && this.requiredRecaptchaMessage) {
        this.requiredRecaptchaMessage.classList.remove('is-hidden');
      } else if (this.requiredInput.checked) {
        this.form.submit();
      } else {
        this.requiredMessage.classList.remove('is-hidden');
      }
    });
  }
}

export default new preventSubmit();



// WEBPACK FOOTER //
// ./src/js/prevent-submit.js